import React from 'react';
import ItemUnit from "./ItemUnit";
import {ALIS, SATIS} from "../constants";

class Item extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="box">
                    <span className="title">{this.props.title || 'Başlıksız'}</span>
                    <div className="work_area">
                        <table style={{width: '100%'}}>
                            <tbody>
                            <tr>
                                <ItemUnit type={ALIS} {...this.props}/>
                                <td style={{width: '5%'}}/>
                                <ItemUnit type={SATIS} {...this.props}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
            </React.Fragment>
        );
    }
}

Item.defaultProps = {
    hasAltin: {alis: 1, satis: 1}
};

export default Item


// WEBPACK FOOTER //
// ./src/component/Item.js